const ajax = async ( url = '', data, options = {} ) => {

    url = new URL( url );

    const defaultOptions = {
        cache:       'no-cache',
        credentials: 'same-origin',
        method:      'GET',
        mode:        'cors',
        redirect:    'follow',
        referrer:    'no-referrer'
    };

    const init = { ...defaultOptions, ...options };

    if ( data ) {

        if ( init.method === 'POST' ) {

            init.body = new FormData();

            Object.entries( data ).forEach( ( [ key, value ] ) => init.body.append( key, value ) );

        } else {

            url.search = new URLSearchParams( data ).toString();

        }

    }

    return fetch( url, init ).then( response => response.json() );

};

export default ajax;